import React from 'react'
import { useAtomValue } from 'jotai'
import { useTranslation } from 'react-i18next'
import { Avatar, Box, Text } from '@node-space/ui-components'
import { ellipseMiddleText } from '@node-space/utils'
import { contactAtom, contactInstrumentAtom } from 'pages/Contacts/atoms/contactAtoms'
import { formatString, roundNumberWithCommas } from 'utils/utils'
import { sendWalletAtom } from '../atoms/atoms'

export const SendDetailsCard = () => {
  const { t } = useTranslation()
  const contact = useAtomValue(contactAtom)
  const contactInstrument = useAtomValue(contactInstrumentAtom)
  const sendWallet = useAtomValue(sendWalletAtom)

  return (
    <Box
      data-testid="send-details-card"
      background="subtle"
      flexCol
      width="full"
      paddingX={12}
      className="py-[10px]"
      gapY={8}
    >
      <Text color="subdued">{t('wallets.send.sendingFromWallet')}</Text>
      <Box flex align="center" gapX={4}>
        <Avatar
          size="small"
          type="currency"
          name={sendWallet?.currency ? sendWallet?.currency?.code?.toLowerCase() : ''}
        />
        <Text variant="body-label">
          {`${sendWallet?.description} | ${formatString(
            t('balanceWithCurrency'),
            roundNumberWithCommas(sendWallet?.balance),
            sendWallet?.currency?.code
          )}`}
        </Text>
      </Box>
      <Text color="subdued">{t('wallets.send.sendingTo')}</Text>
      <Box flex align="center" gapX={4}>
        <Avatar
          size="small"
          type="entity"
          name={contact?.name ? contact?.name.charAt(0).toUpperCase() : ''}
        />
        <Text variant="body-label">{`${contact?.name ? contact?.name : ''} | ${ellipseMiddleText(contactInstrument?.address, 6, 6)}`}</Text>
      </Box>
    </Box>
  )
}
